export default __webpack_public_path__ + "static/media/thumbnail.733ac787.png";